import { useNavigate } from "react-router-dom";
import constant from "./Constant";
import { cloneElement, useEffect } from "react";

const Protected = ({ children, mode, name, ...rest }) => {
    const navigate = useNavigate();
    const host = window.location.hostname;

    const isAllowed =
        host === constant.localDomain ||
        host === constant.qaDomain ||
        (mode.includes("kitchen") && constant.kitchenProtectedDomains.includes(host)) ||
        (mode.includes("meals") && constant.mealsProtectedDomains.includes(host));

    useEffect(() => {
        if (!isAllowed) {
            navigate('/noaccess', { state: { name } });
        }
    }, [isAllowed, navigate, name]);

    if (!isAllowed) return null;

    return cloneElement(children, rest);
};

export default Protected;